import React from 'react';

import { IconButton } from 'packages/common-frontend/components/IconButton';
import { FiUpload } from 'react-icons/fi';

type UploadJsonButtonProps = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
export const UploadJsonButton = ({ setIsOpen }: UploadJsonButtonProps) => {
  return (
    <IconButton
      onClick={() => setIsOpen(true)}
      icon={<FiUpload />}
      ariaLabel="upload"
      label="Upload Credit Agreement JSON"
    />
  );
};
